import React from 'react'
import { useMediaQuery } from 'react-responsive'
import theme from '@/components/themes/mainTheme'
import Grid from '@mui/material/Grid2'
import Divider from '@mui/material/Divider'
import Image from '@/components/image/Image'
import VideoButton from '@/components/buttons/VideoButton'

const videoData = [
  {
    header: 'Yggdrasil - 2024',
    subHeader: 'Lilla Kulturdagen',
    description: 'Välkomna till ett spännande äventyr i den nordiska mytologins värld! Teatersmedjans barngrupper i Blekinge berättar sagan om Yggdrasil, världsträdet som växte fram ur Ginnungagapet. Vi får höra om hur jätten Ymers kropp blev till vår värld, träffa den farliga draken Nidhögg och upptäcka de nio magiska världarna som trädet håller ihop. Och till slut får vi veta vad som händer när allt går under i Ragnarök! Föreställningen är gjord för barn - och framförd av barn!',
    image: 'yggdrasil.png',
    link: 'https://youtu.be/gIZcHjLcDv8',
  },
  {
    header: 'Svärdet i Stenen - 2024',
    subHeader: 'Sommarteater',
    description: 'Svärdet i Stenen (2024) gav oss ädla riddare, klingande svärd & mörka makter - allt vad man önskar sig i en klassisk saga. I denna nytolkning av den outtröttliga klassikern bjöds publiken in till en sprudlande frisk fläkt av teatral spelglädje, vacker musik & rafflande svärdstrider!',
    image: 'svardet-i-stenen.jpg',
    link: 'https://www.youtube.com/watch?v=ZU8YpzYq9ws',
  },
]

const Home: React.FC = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.values.md}px)`
  })

  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'
      textAlign='center'
    >
      <Grid size={10}>
        {isMobile ? (
          <h2 style={{ marginBottom: 0 }}>Välkommen till Teatersmedjan Play!</h2>
        ) : (
          <h1 style={{ marginBottom: 0 }}>Välkommen till Teatersmedjan Play!</h1>
        )}
      </Grid>

      <Grid size={{ xs: 11, md: 5 }} textAlign='start' offset={{ xs: 0, md: -5 }}>
        <h3>LÄS DETTA INNAN DU ANVÄNDER TEATERSMEDJAN PLAY</h3>
        <p>
          Här visas de dokumentationer som Teatersmedjan har rättigheter
          att visa inom den interna gruppen vi kallar för föreningens medlemmar.
        </p>

        <p>
          <b>Du får inte:</b><br/>
          Sprida länken till någon annan.<br/>
          Dela ditt lösenord till någon annan.<br/>
          Ladda ned materialet.<br/>
          Visa upp materialet under arrangerad visning utanför ditt hem.<br/>
          Ta betalt för visning av uppladdat material.<br/>
        </p>

        <p>
          <b>
            Teatersmedjan kommer omgående att ta ned sidan om spridning av
            innehållet eller annan ej tillåten brukning av innehållet
            förekommer - då detta kan innebära straffavgifter för föreningen.
          </b>
        </p>
        <p>
          Annars - mycket nöje! / 
          <b>Verksamhetsproducent Povel Andersson</b>
        </p>
      </Grid>

      {videoData.map((video, index) => (
        <Grid
          key={index}
          container
          size={{ xs: 11, md: 10 }}
          spacing={2}
          direction='row'
          justifyContent='center'
          alignItems='center'
          textAlign='center'
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <Image src={`/images/videos/${video.image}`} height='180px'/>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <p style={{ textAlign: 'start' }}>{video.description}</p>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <VideoButton href={video.link}/>
          </Grid>
          <Divider/>
        </Grid>
      ))}
    </Grid >
  )
}

export default Home